import { Controller } from "@hotwired/stimulus"

export class InviteBookingController extends Controller {
    connect() {
        this.form = this.element.querySelector("#new_booking")
        this.update = () => {
            const agree = this.element.querySelector("[data-terms-agree]")
            // The fine-print preview unchecks the real checkbox without an event,
            // so the sheet's copy follows it on every update.
            this.element.querySelectorAll("[data-terms-agree-mirror]").forEach((mirror) => {
                mirror.checked = !!agree?.checked
            })
            const valid = !!this.form && this.form.checkValidity()
            this.element.querySelectorAll("[data-invite-confirm], [data-booking-confirm]").forEach((confirm) => {
                confirm.disabled = !valid
            })
        }
        this.sync = (event) => {
            if (event.target.matches?.("[data-terms-agree-mirror]")) {
                const agree = this.element.querySelector("[data-terms-agree]")
                if (agree) agree.checked = event.target.checked
            }
            this.update()
        }
        this.validate = (event) => {
            if (event.target === this.form && event.submitter?.name !== "preview" && !this.form.reportValidity()) {
                event.preventDefault()
            }
        }
        this.element.addEventListener("input", this.sync)
        this.element.addEventListener("change", this.sync)
        this.element.addEventListener("submit", this.validate)
        // Timeslot inputs and the fine-print preview arrive as DOM updates.
        this.observer = new MutationObserver(this.update)
        this.observer.observe(this.element, { childList: true, subtree: true })
        this.update()
    }

    disconnect() {
        this.element.removeEventListener("input", this.sync)
        this.element.removeEventListener("change", this.sync)
        this.element.removeEventListener("submit", this.validate)
        this.observer?.disconnect()
    }
}
